import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkforce = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 207,
	height: 207,
	viewBox: "0 0 207 207",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 207,
			height: 207,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 101.388,
			cy: 107.724,
			r: 55.9745,
			stroke: "#8DC3F2",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.702 118.286H118.814V116.173C118.814 112.101 118.597 108.805 117.126 106.203C115.925 104.077 114.037 102.649 111.476 101.473C112.41 99.5298 112.933 97.35 112.933 95.051C112.933 86.8965 106.357 80.2653 98.2194 80.2653C90.0819 80.2653 83.5057 86.8965 83.5057 95.051C83.5057 97.35 84.0291 99.5298 84.963 101.473C82.4015 102.649 80.5143 104.077 79.3128 106.203C77.8421 108.805 77.625 112.101 77.625 116.173V118.286H79.7373H116.702Z",
			fill: "#1B87E6",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.909 59.1429H118.022V57.0306C118.022 53.9876 117.868 51.3808 116.688 49.2931C115.792 47.7087 114.435 46.6225 112.684 45.7519C113.281 44.3498 113.611 42.8066 113.611 41.1888C113.611 34.7841 108.445 29.5714 102.048 29.5714C95.6503 29.5714 90.4845 34.7841 90.4845 41.1888C90.4845 42.8066 90.8147 44.3498 91.4112 45.7519C89.6611 46.6225 88.3037 47.7087 87.4082 49.2931C86.2282 51.3808 86.074 53.9876 86.074 57.0306V59.1429H88.1862H115.909Z",
			fill: "#54A5EC",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.58 102.972H177.693V100.86C177.693 97.8167 177.538 95.2098 176.358 93.1221C175.463 91.5378 174.106 90.4516 172.355 89.581C172.952 88.1789 173.282 86.6357 173.282 85.0179C173.282 78.6131 168.116 73.4005 161.719 73.4005C155.321 73.4005 150.155 78.6131 150.155 85.0179C150.155 86.6357 150.486 88.1789 151.082 89.581C149.332 90.4516 147.975 91.5378 147.079 93.1221C145.899 95.2098 145.745 97.8167 145.745 100.86V102.972H147.857H175.58Z",
			fill: "#54A5EC",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.762,
			cy: 99.5395,
			r: 10.8253,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.1824 102.972H57.2947V100.86C57.2947 97.8167 57.1405 95.2098 55.9605 93.1221C55.065 91.5378 53.7076 90.4516 51.9574 89.581C52.554 88.1789 52.8841 86.6357 52.8841 85.0179C52.8841 78.6131 47.7184 73.4005 41.3208 73.4005C34.9232 73.4005 29.7575 78.6131 29.7575 85.0179C29.7575 86.6357 30.0876 88.1789 30.6842 89.581C28.934 90.4516 27.5766 91.5378 26.6811 93.1221C25.5011 95.2098 25.347 97.8167 25.347 100.86V102.972H27.4592H55.1824Z",
			fill: "#54A5EC",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.5855 164.227H83.6977V162.115C83.6977 159.072 83.5436 156.465 82.3636 154.377C81.468 152.793 80.1106 151.707 78.3605 150.836C78.957 149.434 79.2872 147.891 79.2872 146.273C79.2872 139.868 74.1215 134.656 67.7239 134.656C61.3263 134.656 56.1605 139.868 56.1605 146.273C56.1605 147.891 56.4907 149.434 57.0873 150.836C55.3371 151.707 53.9797 152.793 53.0842 154.377C51.9042 156.465 51.75 159.072 51.75 162.115V164.227H53.8623H81.5855Z",
			fill: "#54A5EC",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.177 172.148H151.29V170.036C151.29 166.993 151.135 164.386 149.955 162.298C149.06 160.714 147.702 159.628 145.952 158.757C146.549 157.355 146.879 155.812 146.879 154.194C146.879 147.789 141.713 142.577 135.316 142.577C128.918 142.577 123.752 147.789 123.752 154.194C123.752 155.812 124.083 157.355 124.679 158.757C122.929 159.628 121.572 160.714 120.676 162.298C119.496 164.386 119.342 166.993 119.342 170.036V172.148H121.454H149.177Z",
			fill: "#54A5EC",
			stroke: "white",
			strokeWidth: 4.22449
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M148.286 105.315V93.7639H149.936C150.848 93.7639 151.587 94.5027 151.587 95.4141V97.0643H154.887C155.798 97.0643 156.537 97.8031 156.537 98.7144V103.665C156.537 104.576 155.798 105.315 154.887 105.315H148.286ZM144.986 97.0643H147.461V105.315H144.986V97.0643Z",
			fill: "#D8D8D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88.4503,
			cy: 55.1824,
			r: 10.8253,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 55.1824,
			cy: 158.154,
			r: 10.8253,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.7071 163.93V152.379H54.3573C55.2687 152.379 56.0075 153.117 56.0075 154.029V155.679H59.3079C60.2193 155.679 60.9581 156.418 60.9581 157.329V162.28C60.9581 163.191 60.2193 163.93 59.3079 163.93H52.7071ZM49.4067 155.679H51.882V163.93H49.4067V155.679Z",
			fill: "#D8D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M85.975 60.9581V49.4067H87.6252C88.5365 49.4067 89.2754 50.1455 89.2754 51.0569V52.7071H92.5757C93.4871 52.7071 94.2259 53.4459 94.2259 54.3573V59.3079C94.2259 60.2193 93.4871 60.9581 92.5757 60.9581H85.975ZM82.6746 52.7071H85.1499V60.9581H82.6746V52.7071Z",
			fill: "#D8D8D8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 104.175,
			y: 108.399,
			width: 22.9413,
			height: 29.8575,
			rx: .674745,
			fill: "white",
			stroke: "#D8D8D8",
			strokeWidth: 1.34949
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.886 112.11L121.887 112.11",
			stroke: "#D8D8D8",
			strokeWidth: 2.69898,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.257 117.557L108.959 118.291L111.064 115.484",
			stroke: "#1B3380",
			strokeWidth: .843431,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.202 115.889H108.986C107.912 115.889 107.042 116.759 107.042 117.832V117.832C107.042 118.905 107.912 119.775 108.986 119.775V119.775C110.059 119.775 110.929 118.905 110.929 117.832V117.832",
			stroke: "#8DC3F2",
			strokeWidth: .809694,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.308 117.846H121.887",
			stroke: "#D8D8D8",
			strokeWidth: 2.69898,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.163 123.072H108.947C107.874 123.072 107.004 123.942 107.004 125.015V125.015C107.004 126.089 107.874 126.959 108.947 126.959V126.959C110.02 126.959 110.89 126.089 110.89 125.015V125.015",
			stroke: "#8DC3F2",
			strokeWidth: .809694,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.169 126.542L110.321 126.389C111.08 125.631 111.08 124.4 110.321 123.641V123.641C109.562 122.882 108.332 122.882 107.573 123.641V123.641C106.814 124.4 106.814 125.631 107.573 126.389V126.389",
			stroke: "#8DC3F2",
			strokeWidth: .809694,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.308 125.099H121.887",
			stroke: "#D8D8D8",
			strokeWidth: 2.69898,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.257 131.923L108.959 132.657L111.064 129.851",
			stroke: "#1B3380",
			strokeWidth: .843431,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.202 130.255H108.986C107.912 130.255 107.042 131.125 107.042 132.199V132.199C107.042 133.272 107.912 134.142 108.986 134.142V134.142C110.059 134.142 110.929 133.272 110.929 132.199V132.199",
			stroke: "#8DC3F2",
			strokeWidth: .809694,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.308 132.184H121.887",
			stroke: "#D8D8D8",
			strokeWidth: 2.69898,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgWorkforce);
export { ForwardRef as ReactComponent };
